(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$timeout', '$window', 'TabFleets', 'Team', 'Context', 'TabDomains', 'User', 'ListObjAndObjType', 'TabObjectsDashboard', 'TabObjectsMap', 'ObjectMap', '$uibModal'];

    function HomeController($scope, $timeout, $window, TabFleets, Team, Context, TabDomains, User, ListObjAndObjType, TabObjectsDashboard, TabObjectsMap, ObjectMap, $uibModal) {
        var vm = this;
        vm.addDomains = addDomains;
        vm.moveDomains=moveDomains;
        vm.domains = [];
        vm.selectDomains = [];
        vm.domainUser = [[]];
        vm.domainUserAdd = [[]];
        vm.domainUserMove = [[]];
        vm.userAddDomains = [[]];
        vm.domainsUser=[[]];
        vm.saveAddDomains = saveAddDomains;
        vm.saveMoveDomains = saveMoveDomains;
        vm.userAddFleets = [[]];
        vm.fleetDomain = [[]];
        vm.fleetAddDomains = [[]];
        vm.saveMoveFleetsDomain = saveMoveFleetsDomain;
        vm.moveFleetsDomain=moveFleetsDomain;
        vm.fleet = {};
        vm.objectType = {};
        vm.load = load;
        $scope.labelsFleets =[];
        $scope.labelsWarnings = [];
        $scope.seriesFleets =[];
        $scope.seriesWarnings = [];
        $scope.dataFleets =[];
        $scope.dataWarnings = [];
        vm.palette = {'AMT':'#26C281','Fan Issue':'#32C5D2','Screen Content':'#E43A45','Firmware Version':'#E87E04','Tamper':'#F3C200','Backlight':'#8E44AD','Temperature':'#3598DC','Temperature Sensor Failure':'#525E64','Humidity':'#C8D046'};
        $scope.colorsFleet = ['#26C281','#32C5D2','#E43A45','#E87E04', '#F3C200', '#8E44AD', '#3598DC', '#525E64', '#C8D046', '#e5e5e5'];

        vm.tabFleet = [];
        vm.objectCounting = {
            online: 0,
            offline: 0,
            warning: 0
        };
        $scope.dataStatus = [];
        $scope.colorStatus = [];
        $scope.labelStatus = [];

        $scope.points = [];

        vm.onlineTrendPrecentage = 0;
        vm.offlineTrendPrecentage = 0;
        vm.untrackedTrendPrecentage = 0;
        vm.warningsTrendPercentage = 0;
        vm.trend = 0;

        vm.markers = [];
        vm.locations = [];
        vm.icons = [];
        vm.labels = [];
        var resUntracked = [];

        User.checkTerms({}, onSuccessCheck, onErrorCheck);

        function onSuccessCheck() {}

        function onErrorCheck() {
            $uibModal.open({
                templateUrl: 'app/components/register-page/terms-conditions.html',
                controller: 'TermsConditionsController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false
            }).result.then(function () {
                $state.reload();
            });
        }

        vm.mapStyle = {};
        var map = ObjectMap.build("object-map");
        var markersLayer = new L.LayerGroup();
        L.gridLayer.googleMutant({
            maxZoom: 24,
            type: 'terrain'
        }).addTo(map);
        resizeFrame();

        function resizeFrame() {
            var offsetY = 140;
            var mapHeight = $window.innerHeight -100;
            mapHeight = mapHeight > 600 ? mapHeight - offsetY : 600;
            vm.mapStyle.height = mapHeight;
            var sizeX = Math.round((mapHeight / 100));

            loadMap();
        }

        function loadMap(){
            TabObjectsMap.home({page:0, size: 100}, onSuccessMap, onErrorMap);
        }

        var boundsArray = [];

        function getCoordinate(object){
            var lat = object.objectLatitude;
            var lng = object.objectLongitude;

            if(!lat || !lng || lat === "null" || lng === "null"){
                lat = object.fieldLatitude;
                lng = object.fieldLongitude;

                if(!lat || !lng || lat === "null" || lng === "null"){
                    lat = null;
                    lng = null;
                }
            }

            return (!lat || !lng) ? null : {lat:lat,lng:lng};
        }

        function onSuccessMap(result, headers) {
            Array.prototype.push.apply(resUntracked, result);
            if (headers('Link') && headers('Link').includes("rel=\"next\"")) {
                var nextPage = resUntracked.length / 100;
                TabObjectsMap.home({page: nextPage, size: 100}, onSuccessMap, onErrorMap);
            } else {
                resUntracked.forEach(function (object) {
                    var coord = getCoordinate(object);
                    if(coord !== null) {
                        var lati = parseFloat(coord.lat), lngi = parseFloat(coord.lng);
                        if(angular.isNumber(lati) && angular.isNumber(lngi)) {
                            vm.locations.push({lat: lati, lng: lngi});
                            vm.icons.push(ObjectMap.getMarkerIconHome(object.objectTracked));
                            vm.labels.push(object.objectName);
                        }
                    }
                });
                // solo quando ha finito tutti gli untracked, carica gli online
                TabObjectsMap.homeOnline(body, onSuccessMapOn, onErrorMapOn);
            }
        }

        function onErrorMap() {
        }

        var body = {
            page: 0,
            size: 100
        };
        var res = [];
        function onSuccessMapOn(result, headers) {
            Array.prototype.push.apply(res,result)
            if (headers('Link').includes("rel=\"next\"")) {
                body.page++;
                TabObjectsMap.homeOnline(body, onSuccessMapOn, onErrorMapOn);
            } else compileMap(res);
        }

        function compileMap(result) {
            result.forEach(function (object) {
                var coord = getCoordinate(object);
                if(coord !== null) {
                    var lati = parseFloat(coord.lat), lngi = parseFloat(coord.lng);
                    if(angular.isNumber(lati) && angular.isNumber(lngi)){
                        vm.locations.push({lat: lati, lng: lngi});
                        vm.icons.push(ObjectMap.getMarkerIconHome(object.objectTracked));
                        vm.labels.push(object.objectName);
                    }
                    // var marker = L.marker([coord.lat, coord.lng], {icon: ObjectMap.getMarkerIconHome(object.objectTracked)})
                    //     .bindPopup("<span>Object: </span>" + object.objectName + "</span>");
                    // markersLayer.addLayer(marker);
                    // boundsArray.push([coord.lat, coord.lng]);
                }
            });
            // markersLayer.addTo(map);
            initMap();
            if (boundsArray.length > 0)
                map.fitBounds(boundsArray, {maxZoom: 16});
            else
                map.fitBounds([[45.501467, 9.132729], [45.426099, 9.244652]]);
        }

        function onErrorMapOn() {
        }

        load();

        function load() {
            Context.query(
                {
                    page: 0,
                    size: 100
                }, function (result, headers) {

                vm.domains = result;
                vm.selectDomains = result;
                vm.domains.forEach(function (d) {
                    d.users = Team.usersDomain({
                        id: d.id,
                        page: 0,
                        size: 100
                    });
                    d.fleets = TabFleets.domains({
                        id: d.id,
                        page: 0,
                        size: 100
                    });
                });
                vm.fleets = TabFleets.users(function (fl) {
                    fl.forEach(function (f) {
                        var page = {
                            id: f.id,
                            query: '',
                            onlyUpdate: false,
                            onlyOnline: false,
                            page: 0,
                            size: 1000
                        };
                        ListObjAndObjType.query(page, onSuccess, onError);

                        function onSuccess(data, headers){
                            $scope.labelsFleets.push(f.fleetName);
                            $scope.seriesFleets.push(f.fleetName);
                            $scope.dataFleets.push(data.tabObjectsList.length);
                        }

                        function onError(){

                        }


                    });
                });
                vm.selectFleet = vm.fleets;
                TabObjectsDashboard.stat(onSuccessDash);

                function onSuccessDash(count) {
                    vm.objectCounting.online = count[0];
                    vm.objectCounting.offline = count[1];
                    vm.objectCounting.warning = count[2];
                    renderChart();

                }

                TabObjectsDashboard.trend(onSuccessTrend);

                function onSuccessTrend(data) {
                    vm.trend = data;
                    vm.onlineTrendPrecentage = ((vm.objectCounting.online - vm.trend[0]) / (vm.trend[0] === 0 ? 1 : vm.trend[0]) * 100).toFixed(0);
                    vm.offlineTrendPrecentage = (((vm.trend[2] - vm.trend[3]) - vm.trend[1]) / ((vm.trend[1] + vm.trend[3]) === 0 ? 1 : (vm.trend[1] + vm.trend[3])) * 100).toFixed(0);
                    vm.warningsTrendPercentage = (((vm.trend[5] - vm.trend[6]) - vm.trend[4]) / ((vm.trend[4] + vm.trend[6]) === 0 ? 1 : (vm.trend[4] + vm.trend[6])) * 100).toFixed(0);
                }

                TabObjectsDashboard.graph(onSuccessGraph);

                function onSuccessGraph(data) {
                    var points = data;
                    points[points.length] = vm.objectCounting.online;

                    new Chart(document.getElementById("line-chart"), {
                        type: 'line',
                        data: {
                            labels: points,
                            datasets: [{
                                data: points,
                                backgroundColor: 'rgba(135, 206, 250, 0.2)',
                                pointRadius: 0,
                                lineTension: 0
                            }]
                        },
                        options: {
                            scales: {
                                xAxes: [{
                                    display: false
                                }],
                                yAxes: [{
                                    display: false,
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }]
                            }
                        }

                    });
                }
            });
        }

        $scope.options = {
            scales: {
                xAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        };

        function addDomains(domain,user,val) {
            if(val) {
                if(!vm.domainsUser[domain])
                    vm.domainsUser[domain] = [];
                TabDomains.byUserLogin({login:user.login}, function (result, headers) {
                    vm.domainsUser[domain][user.id] = result;
                });

            }
            if(!vm.domainUser[domain])
                vm.domainUser[domain] = [];
            vm.domainUser[domain][user.id] = val;
            if(!vm.domainUserAdd[domain])
                vm.domainUserAdd[domain] = [];
            vm.domainUserAdd[domain][user.id] = val;
        }

        function saveAddDomains(domain,user) {
            user = User.get({login:user.login}, function(res){
                var user = res;
                user.domains = vm.domainsUser[domain][user.id];
                User.update(user, onSaveSuccess, onSaveError);
                function onSaveSuccess(result) {
                    vm.domainUser[domain][user.id] = false;
                    vm.domainUserAdd[domain][user.id] = false;
                    load();
                }

                function onSaveError() {
                }
            });

        }

        function moveDomains(domain,index,val) {
            if(!vm.domainUser[domain.id])
                vm.domainUser[domain.id] = [];
            vm.domainUser[domain.id][index] = val;
            if(!vm.domainUserMove[domain.id])
                vm.domainUserMove[domain.id] = [];
            vm.domainUserMove[domain.id][index] = val;
            if(!vm.userAddDomains[domain.id])
                vm.userAddDomains[domain.id] = [];
            vm.userAddDomains[domain.id][index] = domain;
        }

        function saveMoveDomains(domain,user) {
            user = User.get({login:user.login}, function(res){
                var user = res;
                var i = 0;
                user.domains.forEach(function (d) {
                    if(d.id == domain.id) {
                        user.domains.splice(i, 1);
                    } else {
                        i++;
                    }
                });
                user.domains.push(vm.userAddDomains[domain.id][user.id]);
                User.update(user, onSaveSuccess, onSaveError);
                function onSaveSuccess(result) {
                    vm.domainUser[domain.id][user.id] = false;
                    vm.domainUserMove[domain.id][user.id] = false;
                    load();
                }

                function onSaveError() {
                }
            });

        }

        function moveFleetsDomain(fleet,domain,val) {
            if(!vm.fleetDomain[fleet.id])
                vm.fleetDomain[fleet.id] = [];
            vm.fleetDomain[fleet.id][domain.id] = val;
            if(!vm.fleetAddDomains[fleet.id])
                vm.fleetAddDomains[fleet.id] = [];
            vm.fleetAddDomains[fleet.id][domain.id] = domain;
        }

        function saveMoveFleetsDomain(fleet,domain) {
            TabFleets.get({id:fleet.id}, function (fl) {
                var fleetToUpdate = fl;
                fleetToUpdate.domains = vm.fleetAddDomains[fleet.id][domain.id];
                fleetToUpdate.users = [];
                TabFleets.update(fleetToUpdate, onSaveSuccess, onSaveError);

                function onSaveSuccess(result) {
                    vm.fleetDomain[fleet.id][domain.id] = false;
                    load();
                }
                function onSaveError() {}
            });
        }

        function renderChart() {
            $scope.dataStatus[0]=(vm.objectCounting.online);
            $scope.labelStatus[0]=("online");
            $scope.colorStatus[0]=('#26C281');
            $scope.dataStatus[1]= (vm.objectCounting.offline);
            $scope.labelStatus[1]=("offline");
            $scope.colorStatus[1]=('#E43A45');
            $scope.dataStatus[2]=(vm.objectCounting.warning);
            $scope.labelStatus[2]=("warnings");
            $scope.colorStatus[2]=('#F3C200');
        }

        vm.trendFormatter = function (number) {
            (number > -0.5 && number <= 0) ? number = 0 : number;
            return number > 0 ? number.length > 3 ? (number/1000).toFixed(1) + "k" : number : number.length > 4 ? (number/1000).toFixed(1) + "k" : number;
        };

        function initMap() {
            var markers = L.markerClusterGroup();

            for (var i = 0; i < vm.locations.length; i++) {
                var coord = vm.locations[i];
                var title = vm.labels[i];
                var icon = vm.icons[i];
                var marker = L.marker(L.latLng([coord.lat, coord.lng]), {icon: icon}).bindPopup("<span>Object: </span>" + title + "</span>");
                marker.addTo(markers);
                boundsArray.push([coord.lat, coord.lng]);
            }

            markers.addTo(map);
        }
    }
})();
